export default {
  name: 'Pagination',
  props: ['current', 'count', 'type'],
  computed: {
    previous() {
      if (this.current === 1) return null
      return this.current - 1
    },
    next() {
      if (this.current >= Math.ceil(this.count / 10)) return null
      return this.current + 1
    },
    first() {
      if (this.current <= 2) return null
      return 1
    },
    last() {
      if (this.current >= Math.ceil(this.count / 10) - 2) return null
      return Math.ceil(this.count / 10)
    }
  },
  methods: {
    changePage(page) {
      this.$store.dispatch(`set${this.type.charAt(0).toUpperCase()}${this.type.slice(1)}Page`, {
        page
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Pagination/script.js